import React, { memo, useEffect, useState } from "react";
import { Row, Col, Input, Form, Tooltip } from "antd";
import {
  SendOutlined,
  LoadingOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { PrimaryColor } from "utils/constants";

const PromptForm = ({
  input,
  setInput,
  setRegenerateInput,
  onSubmit,
  disabled,
  loading,
  connectionError,
  ...props
}) => {
  const [hasInput, setHasInput] = useState(false);
  return (
    <Row
      align="middle"
      style={{
        // border: "1px solid #d9d9e3",
        // boxShadow: "0px 0px 32px rgba(0, 0, 0, 0.15)",
        borderTop: "1px solid rgba(0,0,0,0.10)",
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        // borderRadius: 8,
        padding: 8,
        backgroundColor: "#fff",
      }}
    >
      <Col
        style={{
          width: "calc(100% - 40px)",
        }}
      >
        <Form
          onKeyDownCapture={(e) => {
            if (e.key === "Enter" && !e.shiftKey && !disabled) {
              e.preventDefault();
              if (onSubmit && !disabled) {
                onSubmit();
                setHasInput("");
              }
            }
          }}
        >
          <Input.TextArea
            // disabled={disabled}
            value={input}
            autoFocus
            autoSize={{ minRows: 1, maxRows: 1 }}
            bordered={false}
            onChange={(e) => {
              if (setInput) {
                setInput(e.target.value);

                // Click on Regenerate button to regenerate the answer
                setRegenerateInput(e.target.value);
              }
              setHasInput(e.target.value.length > 0);
            }}
          />
        </Form>
      </Col>
      <Col
        style={{
          display: "flex",
          justifyContent: "end",
          width: 40,
        }}
      >
        <div
          style={{
            backgroundColor: hasInput ? PrimaryColor : null,
            height: 32,
            width: 32,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 8,
          }}
        >
          <SendOutlined
            style={{
              color: hasInput ? "#fff" : null,
            }}
          />
          {/* {loading && (
            <LoadingOutlined
              style={{
                color: hasInput ? "#fff" : null,
              }}
            />
          )}
          {connectionError && (
            <Tooltip title="Connection Error">
              <WarningOutlined
                style={{
                  color: hasInput ? "#fff" : "red",
                }}
              />
            </Tooltip>
          )}
          {!loading && !connectionError && (
            <SendOutlined
              style={{
                color: hasInput ? "#fff" : null,
              }}
            />
          )} */}
        </div>
      </Col>
    </Row>
  );
};

export default PromptForm;
